import {
  GetAllowedFileExtensions
} from '../../api/document.js'
// import { useToast } from "vue-toastification";
// import i18n from '../../locales/i18n'

// const toast = useToast();

const state = () => ({
  documents: [],
  allowedExtensions: []
})

// getters
const getters = {
}

// actions
const actions = {

  async getAllowedFileExtensions ({ commit }) {
    const fileExtensionsResponse = await GetAllowedFileExtensions()
    commit('setFileExtensions', fileExtensionsResponse.data)
  }
}

const mutations = {
  setDocuments (state, data) {
    state.documents = data.sort((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : -1)
  },
  setFileExtensions (state, data) {
    state.allowedExtensions = data
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
